import { TreeToolbar } from "slot-definitions"
import { UndoLive } from "routes/schedule/undo-portal"
import { Undo } from "routes/schedule/plugins/undo-redo/undo"

TreeToolbar.plug(
    <UndoLive>
        <Undo $lazy priority={10} />
    </UndoLive>
)
